module.exports = __webpack_public_path__ + "img/beijing_you.67fc9557.png";